import {
  DIVISION_MANU_LIST,
  DIVISION_DETAIL_MANU_LIST,
  PRODUCT_DIVISION_LIST,
  FIELDFORCE_DIVISION_LIST,
  DOCTOR_DIVISION_LIST,
  PHARMACY_DIVISION_LIST,
  DOCTOR_DIV_VIEW,
  PHARMACY_DIV_VIEW,
  REIMBURSEMENT_LIST,
  CREATE_DIVISION,
  EDIT_DIVISION,
  ENABLE_DISABLE_DIVISION,
  PRODUCT_DIVISION_VIEW,
  PRODUCT_BULK_VERIFY,
  PRODUCT_CSV_UPLOAD,
  FIELD_FORCE_CSV_UPLOAD,
  FIELD_FORCE_BULK_VERIFY,
  DISTRIBUTOR_CSV_UPLOAD,
  DISTRIBUTOR_BULK_VERIFY,
  DOCTOR_CSV_UPLOAD,
  DOCTOR_BULK_VERIFY,
  PHARMACY_CSV_UPLOAD,
  PHARMACY_BULK_VERIFY,
  DOCTOR_CREATE,
  PHARMACY_CREATE,
} from "./types";

export const divisionList = (data, onSuccess, onError) => {
  return {
    type: DIVISION_MANU_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const DivisionDetail = (id, onSuccess, onError) => {
  return {
    type: DIVISION_DETAIL_MANU_LIST,
    id,
    onSuccess,
    onError,
  };
};

export const productDivisionList = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_DIVISION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceDivisionList = (data, onSuccess, onError) => {
  return {
    type: FIELDFORCE_DIVISION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const createDoctorAction = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const doctorDivisionList = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_DIVISION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const createPharmacyAction = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyDivisionList = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_DIVISION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const doctorProductDivisionView = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_DIV_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const pharmacyDivView = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_DIV_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const reimbursementList = (onSuccess, onError) => {
  return {
    type: REIMBURSEMENT_LIST,
    onSuccess,
    onError,
  };
};

export const divisionCreate = (data, onSuccess, onError) => {
  return {
    type: CREATE_DIVISION,
    data,
    onSuccess,
    onError,
  };
};

export const divisionEdit = (data, onSuccess, onError) => {
  return {
    type: EDIT_DIVISION,
    data,
    onSuccess,
    onError,
  };
};

export const enableDisableDivision = (id, onSuccess, onError) => {
  return {
    type: ENABLE_DISABLE_DIVISION,
    id,
    onSuccess,
    onError,
  };
};

// BULK UPLOAD

export const productCsvUpload = (data, file, onSuccess, onError) => {
  return {
    type: PRODUCT_CSV_UPLOAD,
    data,
    file,
    onSuccess,
    onError,
  };
};

export const productBulkVerify = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_BULK_VERIFY,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceCsvUpload = (data, file, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_CSV_UPLOAD,
    data,
    file,
    onSuccess,
    onError,
  };
};
export const fieldForceBulkVerify = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_BULK_VERIFY,
    data,
    onSuccess,
    onError,
  };
};
export const distributorCsvUpload = (data, file, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_CSV_UPLOAD,
    data,
    file,
    onSuccess,
    onError,
  };
};
export const distributorBulkVerify = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_BULK_VERIFY,
    data,
    onSuccess,
    onError,
  };
};
export const doctorCsvUpload = (data, file, onSuccess, onError) => {
  return {
    type: DOCTOR_CSV_UPLOAD,
    data,
    file,
    onSuccess,
    onError,
  };
};
export const doctorBulkVerify = (data, onSuccess, onError) => {
  return {
    type: DOCTOR_BULK_VERIFY,
    data,
    onSuccess,
    onError,
  };
};
export const pharmacyCsvUpload = (data, file, onSuccess, onError) => {
  return {
    type: PHARMACY_CSV_UPLOAD,
    data,
    file,
    onSuccess,
    onError,
  };
};
export const pharmacyBulkVerify = (data, onSuccess, onError) => {
  return {
    type: PHARMACY_BULK_VERIFY,
    data,
    onSuccess,
    onError,
  };
};
